export default "/images/vendor/pannellum-react/es/pannellum/css/background.svg?73c746e88409ccb4b512c5bb4565ffce";